import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';

import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations';
import Flight from '../entities/flight/flight';

interface FlightState extends ListState<Flight> {
  select: Flight;
  availabilityRoutes: any[];
}

class FlightMutations extends ListMutations<Flight> {}

class FlightModule extends ListModule<FlightState, any, Flight> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<Flight>(),
    loading: false,
    availabilityRoutes: new Array<any>(),
  };
  actions = {
    async getFlightAvailabilityPanel(
      context: ActionContext<FlightState, any>,
      payload: any
    ) {
      context.state.loading = true;
      const response = await Ajax.get(
        '/api/services/app/Flight/GetFlightAvailabilityPanel',
        { params: { ...(payload && payload.data ? payload.data : {}) } }
      );
      context.state.loading = false;
      context.state.availabilityRoutes = response.data.result.routes || [];
      return response;
    },
    async searchFlight(context: ActionContext<FlightState, any>, payload: any) {
      context.state.loading = true;
      let reponse = await Ajax.post(
        '/api/services/app/flight/Search',
        payload.data
      );

      context.state.loading = false;
      const flightsObj = (reponse.data.result &&
        reponse.data.result.flights) || {};
      let flat: any[] = [];
      Object.keys(flightsObj).forEach((k) => {
        flat = flat.concat(flightsObj[k] || []);
      });
      context.state.list = flat;
      return reponse;
    },
    async addFlights(context: ActionContext<FlightState, any>, payload: any) {
      context.state.loading = true;
      const response = await Ajax.post(
        '/api/services/app/Provider/addFlights',
        payload.data
      );
      context.state.loading = false;
      return response;
    },
    async checkFlightSales(context: ActionContext<FlightState, any>, payload: any) {
      context.state.loading = true;
      const response = await Ajax.post(
        '/api/services/app/flight/CheckFlightSales',
        payload.data
      );
      context.state.loading = false;
      return response;
    },
    async getFlightTreeList(
      context: ActionContext<FlightState, any>,
      payload: any
    ) {
      context.state.loading = true;
      console.log(payload);

      const response = await Ajax.get(
        '/api/services/app/Provider/GetFlightTreeList',
        { params: { ...payload.data } }
      );
      context.state.loading = false;
      return response;
    },

    async getFlightOrderTreeList(
      context: ActionContext<FlightState, any>,
      payload: any
    ) {
      context.state.loading = true;

      const response = await Ajax.get(
        '/api/services/app/Booking/GetFlightOrderTreeList',
        { params: { ...payload.data } }
      );
      context.state.loading = false;
      return response;
    },

    async getFlightOrder(context: ActionContext<FlightState, any>, payload: any) {
      context.state.loading = true;
      const response = await Ajax.get('/api/services/app/Booking/GetFlightOrder', {
        params: { Id: payload.data },
      });
      return response;
    },

    async getFlights(context: ActionContext<FlightState, any>, payload: any) {
      context.state.loading = true;
      const response = await Ajax.get('/api/services/app/Flight/GetFlights', {
        params: { Id: payload.data },
      });
      return response;
    },

    async updateFlights({ state }, payload: any) {
      const response = await Ajax.post(
        '/api/services/app/Flight/SaveFlights',
        payload.data
      );
      return response;
    },
  };
  mutations = {
    setCurrentPage(state: FlightState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: FlightState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const flightModule = new FlightModule();
export default flightModule;
